<template>
  <!-- new member board -->
    <div class="">
      <div v-if="selectedMember">
        <div :class="{'member-active':true, 'drawerClose': !openMemberBoardDrawer }" @click="handleDrawerClicked">
          <!-- tablet and up -->
          <div class="member-info">
              <div class="member-avatar">
                <div>
                  <el-avatar class="active-border" :src="getMemberAvatar(selectedMember)" :size=" 40"  icon="el-icon-user-solid" alt="avatar"/>
                </div>
              </div>
              <div class="member-detail">
                <span class="member-name">
                  <div class="name">
                    {{isTabletAndSmaller? `${get(selectedMember.profile, 'firstName', '').charAt(0)}.`  :get(selectedMember.profile, 'firstName', '')}} {{get(selectedMember.profile, 'lastName', '')}}
                  </div>
                </span>
                <span class="member-gender-age d-flex justify-content-between flex-fill">
                  {{get(selectedMember.profile, 'gender') ===  'Male' ||  get(selectedMember.profile, 'gender') ===  'Female'? `${get(selectedMember.profile, 'gender')},`: 'Other,'}} {{calculateAge(get(selectedMember.profile, 'dob', ''))}}
                  <span v-if="selectedMember.mainProfile && !isTabletAndSmaller">
                      <el-tag size="mini" class="primary-member-tag">
                        Primary
                      </el-tag>
                     </span>
                </span>
              </div>
              <div class="member-operation h-100 w-100" v-if="!isTabletAndSmaller" @click.stop>
            <el-dropdown class="h-100 w-100" @command="handleOperationAction" trigger="click">
              <span class="el-dropdown-link d-flex justify-content-end align-items-center  w-100 h-100" @click.stop>
                <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type:'view', member:selectedMember }">View Details</el-dropdown-item>
                  <el-dropdown-item :command="{type:'default', member:selectedMember}">Make Default</el-dropdown-item>
                  <el-dropdown-item :command="{type:'delete',member:selectedMember }" divided>Remove  <i class="el-icon-delete c-dangerous"></i> </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <el-collapse-transition>
          <el-card v-if="openMemberBoardDrawer">
            <div class="team-board">
              <div class="member-list">
                <div class="main-list" v-for="member in mainMembers" :key="member._id" >
                  <div class="member-info">
                    <div class="member-avatar">
                      <el-avatar :src="getMemberAvatar(member)" :size="40"  icon="el-icon-user-solid" alt="avatar"/>
                    </div>
                    <div class="member-detail" @click="selectMember(member)">
                      <span class="member-name">{{member.profile.firstName}} {{member.profile.lastName}}
                      </span>
                      <div >
                        <span class="member-gender-age d-flex justify-content-between flex-fill">{{member.profile.gender}}, {{calculateAge(member.profile.dob)}}
                          <span>
                        <el-tag size="mini" class="primary-member-tag">
                          Primary
                        </el-tag>
                       </span>
                       <span v-if="isActiveMember(member)">
                        <el-tag size="mini" class="active-member-tag">
                          <i class="el-icon-success"></i>
                          Active
                        </el-tag>
                       </span>
                        </span>
                      </div>
                    </div>
                    <div class="member-operation h-100 w-100">
                      <el-dropdown class="h-100 w-100" @command="handleOperationAction" trigger="click">
              <span class="el-dropdown-link d-flex justify-content-end align-items-center  w-100 h-100" @click.stop>
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type:'view', member:member }">View Details</el-dropdown-item>
                  <el-dropdown-item :command="{type:'default', member:member}">Make Default</el-dropdown-item>
                  <el-dropdown-item :command="{type:'delete',member:member }" divided>Remove  <i class="el-icon-delete c-dangerous"></i> </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
                </div>
                  </div>
                </div>
                <!-- <el-divider></el-divider> -->
                <div :class="{'main-list': true, 'isActive': isActiveMember(member)}" v-for="member in sideMembers" :key="member._id" >
                  <div class="member-info">
                    <div class="member-avatar">
                      <el-avatar :src="getMemberAvatar(member)" :size="40" icon="el-icon-user-solid" alt="avatar"/>
                    </div>
                    <div class="member-detail" @click="selectMember(member)">
                      <span class="member-name">{{member.profile.firstName}} {{member.profile.lastName}}
                        <span v-if="isActiveMember(member)">
                      <el-tag size="mini" class="active-member-tag">
                        <i class="el-icon-success"></i>
                        Active
                      </el-tag>
                     </span>
                      </span>
                      <span class="member-gender-age">{{member.profile.gender ===  'Male' ||  member.profile.gender ===  'Female'? `${member.profile.gender},`: 'Other,'}} {{calculateAge(member.profile.dob)}}</span>
                    </div>
                    <div class="member-operation h-100 w-100">
                      <el-dropdown class="h-100 w-100" @command="handleOperationAction" trigger="click">
              <span class="el-dropdown-link d-flex justify-content-end align-items-center  w-100 h-100" @click.stop>
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type:'view', member:member }">View Details</el-dropdown-item>
                  <el-dropdown-item :command="{type:'default', member:member}">Make Default</el-dropdown-item>
                  <el-dropdown-item :command="{type:'delete',member:member }" divided>Remove  <i class="el-icon-delete c-dangerous"></i> </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
                </div>
                  </div>
                </div>
                <div class="add-team-member">
                  <el-button type="text" @click.native="addMemberModal.visible = true"> + Add members</el-button>
                </div>
              </div>
            </div>
        </el-card>
        </el-collapse-transition>
      </div>
      <div v-if="!members.length" class="add-first-member">
            <div class="team-board">
                <div class="add-team-member">
                  <el-button type="text" @click.native="addMemberModal.visible = true">
                    + Add First Member
                    <!-- information bubble ask user to create member so that product can display for eligible member-->
                    <el-tooltip class="item" effect="dark" content="Add first member to view eligible products" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </el-button>
                </div>
            </div>
          </div>

      <el-dialog
      :title="addMemberModal.page.title"
      :visible.sync="addMemberModal.visible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="beforeAddMemberModalClose"
      :append-to-body="true">
      <new-member v-if="addMemberModal.page.name === 'new-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="fetchMembers" />
      <link-member v-if="addMemberModal.page.name === 'link-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="fetchMembers" :data="addMemberModal.data" />
      <verify-member v-if="addMemberModal.page.name === 'verify-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="fetchMembers" :data="addMemberModal.data" />
    </el-dialog>
    </div>
</template>

<script>
import { calculateMemberAge } from '@/utils/helpers';
import _ from 'lodash';
import moment from 'moment';
import NewMember from './NewMember.vue';
import LinkMember from './LinkMember.vue';
import VerifyMember from './VerifyMember.vue';

export default {
  components: {
    NewMember,
    LinkMember,
    VerifyMember,
  },
  props: {
    atFinder: {
      type: Boolean,
      default: false
    },
    collapsibleAtFinder: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      get: _.get,
      openMemberBoardDrawer: true,
      //   direction: 'rtl',
      innerWidth: window.innerWidth,
      members: [],
      isExpanded: false,
      selectedMember: undefined,
      addMemberModal: {
        visible: false,
        page: {
          name: 'new-member',
          title: 'Add Member'
        },
        data: undefined
      },
    };
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    const activeMember = this.$store.getters['user/activeMember'];
    const isDrawerOpened = this.$store.getters['user/isMemberBoardDrawerOpened'];
    if (this.innerWidth <= 992) {
      this.openMemberBoardDrawer = false;
    } else {
      this.openMemberBoardDrawer = isDrawerOpened;
    }

    // Emit initial state for dashboard padding
    this.$emit('memberBoardStateChanged', this.openMemberBoardDrawer);
    if (activeMember?._id) {
      this.selectedMember = activeMember;
      this.$emit('selectMemberAtFinder', activeMember);
    }
    await this.fetchMembers();
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    isMediumAndSmaller() {
      if (this.atFinder) {
        return this.innerWidth <= 1230;
      }
      return this.innerWidth <= 1800;
    },
    isTabletAndSmaller() {
      // if (this.collapsibleAtFinder) {
      //   return false;
      // }
      if (this.atFinder) {
        return false;
      }
      return this.innerWidth <= 300;
    },
    sideMembers() {
      const sideMembers = this.members.filter((member) => !member.mainProfile);
      // return sideMembers filter out the selected member
      return sideMembers.filter((member) => (this.selectedMember && member._id !== this.selectedMember._id) || !this.selectedMember);
      // return this.members.filter((member) => !member.mainProfile);
    },
    mainMembers() {
      return this.members.filter((member) => (this.selectedMember && member.mainProfile && member._id !== this.selectedMember._id) || !this.selectedMember);
    },

  },
  methods: {
    handleDrawerClicked() {
      this.openMemberBoardDrawer = !this.openMemberBoardDrawer;
      this.$store.commit('user/setOpenMemberBoardDrawer', this.openMemberBoardDrawer);
      // Emit state change for dashboard padding adjustment
      this.$emit('memberBoardStateChanged', this.openMemberBoardDrawer);
    },
    updateVisible(val) {
      this.addMemberModal.visible = val;
    },
    async fetchMembers() {
      const resMember = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
      if (resMember.data) {
        this.members = resMember.data.data;
        // add selected property to each member
        this.members.forEach((member) => {
          if (member.mainProfile) {
            _.assign(member, { selected: true });
            if (!this.selectedMember || !_.get(this, 'selectedMember._id')) {
              this.selectedMember = member;
              this.$store.commit('user/setActiveMember', member);
            }
          } else {
            _.assign(member, { selected: false });
          }
        });
        // if there is no selected member, select the first member
        if (!this.selectedMember) {
          [this.selectedMember] = this.members;
          this.$store.commit('user/setActiveMember', this.selectedMember);
        }
      }
    },
    updatePage(page, data) {
      this.addMemberModal.page = page;
      this.addMemberModal.data = data;
    },
    beforeAddMemberModalClose() {
      this.addMemberModal = {
        visible: false,
        page: {
          name: 'new-member',
          title: 'Add Member'
        },
        data: undefined
      };
    },
    isActiveMember(member) {
      return this.selectedMember && this.selectedMember._id === member._id;
    },
    async selectMember(member) {
      //  deselect all members
      this.members.forEach((m) => {
        _.assign(m, { selected: false });
      });
      //  select the member to the this.members
      const index = this.members.findIndex((m) => m._id === member._id);
      _.assign(this.members[index], { selected: true });
      this.selectedMember = member;
      this.openMemberBoardDrawer = false;
      this.$store.commit('user/setActiveMember', member);
      this.$store.commit('loading', true, 'Loading member registrations...');

      const response = await this.getMemberMembership(member._id);
      const memberMembership = response.data.data;
      this.$store.commit('loading', false);
      this.$store.commit('user/setMemberRegos', memberMembership);
      this.$emit('selectMemberAtFinder', member);
      this.$forceUpdate();

      // this.$emit('selectMember', member);
    },
    async getMemberMembership(memberId) {
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${memberId}`);
      return response;
    },
    handleOperationAction(action) {
      if (action.type === 'view') {
        const pathName = this.hasCustomEntity ? 'custom-profile' : 'profile';
        this.$router.push({ name: pathName, params: { id: action.member._id } });
      } else if (action.type === 'default') {
        if (!action.member.mainProfile) {
          const memberIndex = this.members.findIndex((member) => member._id === action.member._id);
          const mainMemberIndex = this.members.findIndex((member) => member.mainProfile);
          this.members[memberIndex].mainProfile = true;
          this.members[mainMemberIndex].mainProfile = false;
          this.$store.commit('loading', true, 'Updating member...');
          // this.$store.commit('loadingText', 'Updating member...');
          this.$http.put(`/assemble/api/v1/account/portal/members/${action.member._id}/primary`)
            .then(() => {
              this.$store.commit('loading', false);
              this.$message.success(`${action.member.profile.firstName} ${action.member.profile.lastName} has been set as primary profile`);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        }
      } else if (action.type === 'delete') {
        this.$confirm('Are you sure you want to unlink this member?', 'Confirm', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
          .then(() => {
            this.$store.commit('loading', true, 'Unlinking member...');
            // this.$store.commit('loadingText', 'Unlinking member...');
            this.$http.put(`/assemble/api/v1/account/portal/members/${action.member._id}/unlink`)
              .then(() => {
                this.$store.commit('loading', false);
                this.$message.success(`${action.member.profile.firstName} ${action.member.profile.lastName} has been unlinked`);
                this.members = this.members.filter((member) => member._id !== action.member._id);
              }).catch((e) => {
                this.$message.error(e.response.data.message);
                this.$store.commit('loading', false);
              });
          })
          .catch(() => {});
      }
    },
    getMemberAvatar(member) {
      return _.get(member, 'meta.imgUrl', '') ? `${member.meta.imgUrl}?v=${moment.valueOf()}` : '';
    },

    handleResize() {
      this.innerWidth = window.innerWidth;
    },
    calculateAge(dob) {
      // const endOfYear = this.$store.getters['national/endOfYear'];
      const currentDate = moment();
      const age = calculateMemberAge(dob, currentDate);
      return age;
    }
  },
  watch: {
    isMediumAndSmaller() {
      this.openMemberBoardDrawer = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-first-member{
  display: flex;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    border-color: #c0c4cc;
  }

  .team-board{
    .add-team-member{
      padding: 1.5rem;
      font-size: 1.1rem !important;
      font-weight: 500;
      color: #409eff;
      text-align: center;

      .el-button {
        border: none;
        background: none;
        color: #409eff;
        font-size: 1.1rem;
        font-weight: 500;

        &:hover {
          color: #66b1ff;
          background: rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}
::v-deep .el-card__header{
  background: var(--secondary-color);
  color: var(--text-color-secondary);
}
::v-deep .el-card__body{
  padding: 0;
}

::v-deep .el-button--text{
  font-size:1.1rem !important;
}
:v-deep .el-dropdown-menu{
  border: 1px solid var(--secondary-color) !important;
}

::v-deep .el-drawer__header{
  background: var(--secondary-color);
  color: var(--text-color-secondary);
  padding:1rem;
  margin:0
}

::v-deep .el-drawer__open .el-drawer.rtl{
  @media only screen and (max-width: 980px) {
    width: 50% !important;
  }
  @media only screen and (max-width: 768px) {
    width: 100% !important;
  }

}
::v-deep .el-card{
  height:100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow-y:auto;
  border: 1px solid #e4e7ed;
  border-radius: 0 0 8px 8px;
  transition: all 0.3s ease;
}
.team-board{
  // width: 30rem;
  max-height: calc(100vh - 80px - 300px);
  // auto scroll when the height is greater than 100vh
  overflow-y: auto;
  .team-board-header{
    background: var(--secondary-color);
    color: var(--text-color-secondary);
    display: flex;
    justify-content: space-between;
    .expand-button{
      // padding: 1rem;
      // font-size: 1.5rem;
      color: var(--text-color-secondary);
      // add hover effect to the button with underline
      &:hover{
        // color: var(--text-color-secondary);
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .member-list{
    height: 100%;
    padding: 1.1rem 0;
    // background-color: #faf8f8;
    .other-members-title{
      padding: 1rem;
      font-size: 1.1rem;
      font-weight: 500;
      color: #2D3A45;
    }
    .add-team-member{
      padding: 1.5rem;
      font-size: 1.1rem !important;
      font-weight: 500;
      color: #409eff;
      text-align: center;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(64, 158, 255, 0.05);
      }

      .el-button {
        border: none;
        background: none;
        color: #409eff;
        font-size: 1.1rem;
        font-weight: 500;

        &:hover {
          color: #66b1ff;
          background: rgba(64, 158, 255, 0.1);
        }
      }
    }
    .isActive{
      background: #409eff;
      color: #ffffff;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

      .member-info .member-gender-age, ::v-deep.el-icon-more {
        color: #ffffff !important;
      }

      &:hover {
        background: #66b1ff;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
      }
    }
    .main-list{
      padding: 1rem;
      margin: 0.5rem;
      border-radius: 8px;
      transition: all 0.3s ease;
      cursor: pointer;

      // add hover effect
      &:hover{
        background: #f5f7fa;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);

        .member-info .member-gender-age, ::v-deep.el-icon-more {
          color: #303133 !important;
        }
      }

      // Mobile touch-friendly interactions
      @media (max-width: 768px) {
        padding: 16px;
        margin: 8px;
        border-radius: 8px;
        min-height: 60px;

        &:active {
          background: var(--secondary-color);
          color: var(--text-color-secondary);
          transform: scale(0.98);

          .member-info .member-gender-age, ::v-deep.el-icon-more {
            color: var(--text-color-secondary) !important;
          }
        }
      }
      .member-info{
        display: grid;
        // width: 200px;
        grid-template-columns: 1fr 4fr 1fr;
        align-items: center;
        .member-detail{
          cursor: pointer;
          display: flex;
          flex-direction: column;
          padding-left:0.5rem;
          .member-name{
            font-size: 1.1rem;
            font-weight: 600;
            color: #303133;
            display: flex;
            gap: 0.5rem;
            align-items: center;
            align-content: center;
            .active-member-tag{
              border-radius: 4px;
              background: #67c23a;
              border-color: #67c23a;
            }
            .primary-member-tag{
              border-radius: 4px;
              background: #409eff;
              border-color: #409eff;
            }
          }
          .member-gender-age{
            font-size: 0.9rem;
            color: #606266;
          }

        }
        .member-operation{
          cursor: pointer;
          text-align: end;
          display: flex;
          justify-content: flex-end;
        }

      }
    }
    .member-info{
        display: grid;
        grid-template-columns: 1fr 5fr 1fr;
        align-items: center;

        // padding: 1rem;
        .member-detail{
          cursor: pointer;
          display: flex;
          flex-direction: column;
          padding-left:0.5rem;
          .member-name{
            font-size: 1.1rem;
            font-weight: 600;
            color: #303133;
            display: flex;
            gap: 0.5rem;
            align-items: center;
            align-content: center;
            .active-member-tag{
              border-radius: 4px;
              background: #67c23a;
              border-color: #67c23a;
            }
            .primary-member-tag{
              border-radius: 4px;
              background: #409eff;
              border-color: #409eff;
            }
          }
          .member-gender-age{
            font-size: 0.9rem;
            color: #606266;
          }

        }
        .member-operation{
          cursor: pointer;
          text-align: end;
          display: flex;
          justify-content: flex-end;
        }

      }
    .active-member{
      padding: 1rem;
    }
    .member-info{
        display: grid;
        grid-template-columns: 1fr 5fr 1fr;
        align-items: center;

        // padding: 1rem;
        .member-detail{
          cursor: pointer;
          display: flex;
          flex-direction: column;
          padding-left:0.5rem;
          .member-name{
            font-size: 1.2rem;
            display: flex;
            gap: 0.5rem;
            align-items: center;
            align-content: center;
            .active-member-tag{
              border-radius: 4px;
              background: #67c23a;
              border-color: #67c23a;
            }
            .primary-member-tag{
              border-radius: 4px;
              background: #409eff;
              border-color: #409eff;
            }
          }
          .member-gender-age{
            font-size: 0.9rem;
            color: #606266;
          }

        }
        .member-operation{
          cursor: pointer;
          text-align: end;
          display: flex;
          justify-content: flex-end;
        }

      }
    .active-member{
      padding: 1rem;
    }
    .secondary-list{
      padding: 1rem;
    }
  }
}
.member-active{
  border: 1px solid #e4e7ed;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
    border-color: #409eff;
  }

  .member-gender-age {
    color: #606266 !important;
    font-size: 0.9rem;
  }

  .name {
    color: #303133 !important;
    font-weight: 600;
    font-size: 1.1rem;
  }

  // Mobile enhancements
  @media (max-width: 768px) {
    min-height: 60px;
    padding: 16px;
    margin: 0;
    border-radius: 8px 8px 0 0;

    .member-info {
      grid-template-columns: auto 1fr auto;
      gap: 12px;
    }

    .member-avatar {
      .el-avatar {
        width: 48px;
        height: 48px;
      }
    }
  }

  .member-info{
    @media only screen and (min-width: 300px) {
      display: grid;
      grid-template-columns: 1fr 5fr 1fr;
      align-items: center;
      .member-detail{
        cursor: pointer;
      display: flex;
      flex-direction: column;
      padding-left:1rem;
      .member-name{
        display: flex;
        gap:10px;
        font-size: 1.1rem;
      }
      .member-gender-age{
        font-size: 1rem;
        color: var(--text-color-secondary)
      }

    }
    .member-avatar{
      // border: 2px solid #4CAF50; /* Adjust the border color and thickness as needed */
      // border-radius:200px; /* Make the border rounded */
      .active-border{
        border: 2px solid #4CAF50; /* Adjust the border color and thickness as needed */
        border-radius:50%; /* Make the border rounded */
        padding: 2px;

      }
    }
  }

  .member-operation{
    cursor: pointer;
    text-align: end;
    display: flex;
    justify-content: flex-end;
  }
  }

}
.drawerClose{
  border-bottom: 1px solid #e4e7ed;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  position: relative;

  @media (max-width: 768px) {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  // &::after {
  //   content: '\25BC'; /* Unicode for downward-pointing triangle */
  //   display: block;
  //   text-align: center;
  //   font-size: 10px;
  //   color: #26276A;
  //   position: absolute;
  //   bottom: 3.5%;
  //   left: 50%;
  //   transform: translateX(-50%);
  //   // background-color: white;
  //   padding: 0 5px;
  // }
}

</style>
